// Version : 0.0.1
// Author : NANDHA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:25-09-2025

/* eslint-disable import/no-anonymous-default-export */
import BranchCollectionReportActionTypes from './branch-collection-report.type';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getBranchCollectionReportListResponse: null,
	getBranchCollectionReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** BRANCH COLLECTION REPORT DETAILS START *********************** */
		case BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_SUCCESS:
			return {
				...state,
				getBranchCollectionReportListResponse: action.payload,
				getBranchCollectionReportListArr: docodeHexResponse(
					action.payload,
					'GetBranchCollectionReportKey',
				),
			};

		case BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_FAILURE:
			return { ...state, getBranchCollectionReportListResponse: action.payload };

		case BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getBranchCollectionReportListResponse: null };
		/** ***************** BRANCH COLLECTION REPORT DETAILS END *********************** */
		default:
			return state;
	}
};
